import useStore from "../../store/store";
import styles from '../../style.module.scss';
import {useEffect, useState} from "react";
import formatHours from "../../utils/format-hours";
import formatDate from "../../utils/format-date";
import {host} from "../../const/const";
import CheckAvailablePopup from "./check-available-popup";

const CheckAvailable = () => {
    const carId = useStore((state) => state.carId)
    const startDate = useStore((state) => state.startDate)
    const startHours = useStore((state) => state.startHours)
    const finishDate = useStore((state) => state.finishDate)
    const finishHours = useStore((state) => state.finishHours)
    const availableMode = useStore((state) => state.availableMode)
    const lang = useStore((state) => state.lang)
    const [available, setAvailable] = useState(true);
    const [message, setMessage] = useState('');
    const [icon, setIcon] = useState(null);
    const [showPopup, setShowPopup] = useState(true);

    const getApiData = async (carId, start, finish, lang) => {
        try {
            const response = await fetch(
                `${host}?action=check_available_car&id=${carId}&start=${start}&finish=${finish}&lang=${lang || 'ru'}`
            ).then((response) => response.json());
            if (response?.message) {
                setAvailable(false);
                setShowPopup(true);
                setMessage(response.message)
                if (response?.icon){
                    setIcon(response.icon)
                }
            } else {
                setAvailable(true);
                setMessage('');
            }
        } catch (error) {
            console.error(error.message);
        }
    };

    useEffect(() => {
        if (startDate && startHours !== null && finishDate && finishHours !== null && carId && availableMode === 1) {
            setShowPopup(true);
            const start = `${formatDate(startDate)} ${formatHours(startHours)}`;
            const finish = `${formatDate(finishDate)} ${formatHours(finishHours)}`;
            getApiData(carId, start, finish, lang);
        }
    }, [startDate, startHours, finishDate, finishHours, carId, availableMode, lang]);

    if (available) {
        return null;
    }

    const periodStart = `${formatDate(startDate)} ${formatHours(startHours)}`;
    const periodFinish = `${formatDate(finishDate)} ${formatHours(finishHours)}`;

    return (
        <>
            <div className={`${styles.availableMessage} p-small-size`}>
                {!!icon && (<img src={icon} width={20} height={20} alt=""/>)}
                {message}
            </div>
            {showPopup && (
                <CheckAvailablePopup
                    carId={carId}
                    start={periodStart}
                    finish={periodFinish}
                    onClose={() => setShowPopup(false)}
                />
            )}
        </>
    );
};

export default CheckAvailable;